/**
 * PM Favourite Product Model
 *
 * TypeScript interfaces for the favourite products feature.
 * Used across service, component, and template.
 */

/**
 * Favourite product as stored in the database
 */
export interface PmFavProduct {
  _id?: string;
  companyId: string;
  supplierName: 'Hyperpure' | 'Udaan' | 'Dmart' | 'Deliverit' | 'Local Supplier';
  supplierDisplayName?: string;
  productName: string;
  productSkuId: string;
  dmartArticleNumber?: string;  // D-mart specific field for API calls
  supplierId?: string;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Payload for adding a favourite product
 */
export interface AddFavProductPayload {
  companyId: string;
  supplierName: string;
  supplierDisplayName?: string;
  productName: string;
  productSkuId: string;
  dmartArticleNumber?: string;  // Required for D-mart favorites
  supplierId?: string;
}

/**
 * Payload for removing a favourite product
 */
export interface RemoveFavProductPayload {
  companyId: string;
  supplierName: string;
  productSkuId: string;
  dmartArticleNumber?: string;  // Required for D-mart favorites
}

/**
 * API Response wrapper
 */
export interface FavProductApiResponse {
  success: boolean;
  message?: string;
  data?: PmFavProduct | PmFavProduct[];
  count?: number;
  error?: string;
  errors?: string[];
}

/**
 * Composite key for quick lookup in a Set/Map
 * Format: "supplierName::productSkuId"
 */
export type FavProductKey = string;

/**
 * Build a composite favourite key for quick lookup
 */
export function buildFavProductKey(supplierName: string, productSkuId: string): FavProductKey {
  return `${supplierName}::${String(productSkuId)}`;
}
